import Model from '@/class/cargo/model/utils/Model'
/**
 * FileType 常量
 */
export class FileType {
  constructor(code, chineseName) {
    this.code = code
    this.chineseName = chineseName
  }
}

export const CODE_NAME = 'FileType'

export const HXD_TYPE = new FileType(0, '核销单')
export const SC_TYPE = new FileType(1, '手册')
export const TD_TYPE = new FileType(2, '提单')
export const BGD_TYPE = new FileType(3, '报关单')
export const INV_TYPE = new FileType(4, '发票')
export const CHIT_TYPE = new FileType(5, '保单')
export const FUM_TYPE = new FileType(6, '熏蒸证书')
export const PERMIT_TYPE = new FileType(7, '许可证')
export const QT_TYPE = new FileType(8, '其它')
export const HBL_TYPE = new FileType(9, 'HBL')
export const BOX_CK_TYPE = new FileType(10, '压箱支票')
export const TAX_LIST_TYPE = new FileType(11, '税单')
export const INSPECTION_TYPE = new FileType(12, '入境检验检疫合格证明')
export const HEALTH_CERTIFICATE_TYPE = new FileType(13, '卫生证书')
export const VIN_TYPE = new FileType(14, 'VIN')
export const CIQ_TYPE = new FileType(15, 'CIQ')
export const FPRZ_TYPE = new FileType(16, '发票认证')
export const CDZ_TYPE = new FileType(17, '产地证')
export const PZZS_TYPE = new FileType(18, '品质证书')
export const CZM_TYPE = new FileType(19, '船证明')
export const SECURE_TYPE = new FileType(20, '保险')
export const FORMA_TYPE = new FileType(21, 'FORM A')

export const FILE_TYPES = [
  HXD_TYPE,
  SC_TYPE,
  TD_TYPE,
  BGD_TYPE,
  INV_TYPE,
  CHIT_TYPE,
  FUM_TYPE,
  PERMIT_TYPE,
  HBL_TYPE,
  BOX_CK_TYPE,
  TAX_LIST_TYPE,
  QT_TYPE,
  INSPECTION_TYPE,
  HEALTH_CERTIFICATE_TYPE,
  VIN_TYPE,
  CIQ_TYPE,
  FPRZ_TYPE,
  CDZ_TYPE,
  PZZS_TYPE,
  CZM_TYPE,
  SECURE_TYPE,
  FORMA_TYPE
]

/**
 *  return null:没找到.
 */
export function getFileTypeByCode(code) {
  return Model.getObjByCode(code, FILE_TYPES)
}

/**
 * 外部文件类型
 */
export const EXTERNAL_FILE_EMPTY = new FileType(0, ' ')
export const EXTERNAL_FILE_HBL = new FileType(1, '提单文件(HBL文件)')
export const EXTERNAL_FILE_BILLING = new FileType(2, '客户账单')
export const EXTERNAL_FILE_INVOICE = new FileType(3, '客户发票')
export const EXTERNAL_FILE_PAYMENT = new FileType(4, '客户付款凭证')
export const EXTERNAL_FILE_DISCHARGE = new FileType(5, '电放单')
export const EXTERNAL_FILE_CONFIRM = new FileType(6, '费用确认单')
export const EXTERNAL_FILE_CONTAINER = new FileType(7, '装箱单')
export const EXTERNAL_FILE_BOOKING = new FileType(8, '托书')

export const EXTERNAL_FILE_TYPES = [
  EXTERNAL_FILE_EMPTY,
  EXTERNAL_FILE_HBL,
  EXTERNAL_FILE_BILLING,
  EXTERNAL_FILE_INVOICE,
  EXTERNAL_FILE_PAYMENT,
  EXTERNAL_FILE_DISCHARGE,
  EXTERNAL_FILE_CONFIRM,
  EXTERNAL_FILE_CONTAINER,
  EXTERNAL_FILE_BOOKING
]
